import { UsersPickerController } from './users-picker.controller';

export const UsersPickerComponent: ng.IComponentOptions = {
  bindings: {
    max: '<',
    selectedUsers: '<',
    onSave: '&',
  },
  templateUrl: 'components/UsersPicker/users-picker.html',
  controller: UsersPickerController,
};
